import React from 'react';
import { Button, FaIcon, FaIcons } from '@innovationnorway/component-library';
import { icon } from '@fortawesome/fontawesome-svg-core';
import BillsForm from './BillsForm';
import { useTranslation } from 'react-i18next';
import { SivaEsaReportingDto } from 'src/api/v2';
import { useParams } from 'react-router-dom';
import { PageParams } from '../types/PageParams';
import { convertIdToNumber } from '../utils/idConversion';

type Props = {
  onSubmit: (bills: SivaEsaReportingDto[]) => void;
  isLoading?: boolean;
  allowEditing: boolean;
  selectedYear: number;
};

const ESANoRegisteredBillsInfo: React.FC<Props> = ({
  onSubmit,
  isLoading = false,
  allowEditing,
  selectedYear,
}) => {
  const { t: tSiva } = useTranslation('siva');
  const [showAddComponent, setShowAddComponent] = React.useState(false);
  const { contractId } = useParams<PageParams>();

  if (showAddComponent) {
    return (
      <BillsForm
        header={tSiva('company.details.esa.bill.add')}
        numericId={convertIdToNumber(contractId)}
        onSubmit={onSubmit}
        isLoading={isLoading}
        onCancel={() => setShowAddComponent(false)}
        selectedYear={selectedYear}
      />
    );
  }

  return (
    <>
      <FaIcon
        className="margin-bottom--3"
        icon={icon({ prefix: 'fal', iconName: 'money-check-dollar-pen' })}
      />
      <div className="margin-bottom--6">{tSiva('company.details.esa.bill.noRegistered')}</div>

      <Button onClick={() => setShowAddComponent(true)} disabled={!allowEditing}>
        <FaIcon name={FaIcons.Plus} className="margin-right--1" />
        {tSiva('company.details.esa.bill.add')}
      </Button>
    </>
  );
};

export default ESANoRegisteredBillsInfo;
